import { useFlowStore } from "#src/stores/flow.js";
import { INSURED_TYPES } from "#src/stores/insured.js";
import {
  stepToApiFriendlyRoute,
  steps,
} from "#src/enumerations/step-enumeration.js";
import { useEappStore } from "#src/stores/electronic-application.js";
import { getStepConfig } from "#src/enumerations/step-config.js";
export class FlowService {
  #pinia;
  constructor(pinia) {
    this.#pinia = pinia;
  }

  setStep(step) {
    const flow = useFlowStore(this.#pinia);
    flow.step = step;
  }

  async advanceStep() {
    const flow = useFlowStore(this.#pinia);
    if (flow.step === steps.QUOTE) this.#validateQuoteStep();
    else {
      const stepConfig = getStepConfig(flow.step, this.#pinia);
      if (!stepConfig?.generateForm)
        throw { step: ["Cannot advance to the next step"] };
      this.validateStep(stepConfig.generateForm);
    }

    const { step } = await flow.goToStep({ step: flow.activeStep.next });
    flow.step = step;

    return { step: stepToApiFriendlyRoute(step) };
  }

  validateStep(form) {
    const eApp = useEappStore(this.#pinia);

    let insuredErrors = {};
    let jointErrors = {};

    insuredErrors = this.#validateFormByInsured("insured", () =>
      form(INSURED_TYPES.INSURED).validate({ throwOnFailure: true })
    );

    if (eApp.isDualInsured) {
      jointErrors = this.#validateFormByInsured("joint_insured", () =>
        form(INSURED_TYPES.JOINT).validate({ throwOnFailure: true })
      );
    }

    const errors = { ...insuredErrors, ...jointErrors };
    if (Object.keys(errors).length) throw errors;
  }

  #validateFormByInsured(insuredKey, validateFn) {
    try {
      validateFn();
    } catch (e) {
      if (!Array.isArray(e)) throw e;
      return e.reduce((accumulator, { property, key }) => {
        accumulator[`${insuredKey}.${key}`] = property.errorMessages;
        return accumulator;
      }, {});
    }
  }

  #validateQuoteStep() {
    const eApp = useEappStore(this.#pinia);
    if (!eApp.selectedQuote.id)
      throw { "insured.quote_id": ["Please select a quote"] };
    if (eApp.isDualInsured && !eApp.selectedQuote.joint_insured_quote_id)
      throw { "joint_insured.quote_id": ["Please select a joint quote"] };
  }
}
